import {createContext} from 'react';

const boardContext = createContext();

export default boardContext;